module.exports = __webpack_public_path__ + "static/media/womens3.0c2c9bf3.jpg";